/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CalendarEventLocation } from './CalendarEventLocation';
import {
    CalendarEventLocationFromJSON,
    CalendarEventLocationFromJSONTyped,
    CalendarEventLocationToJSON,
    CalendarEventLocationToJSONTyped,
} from './CalendarEventLocation';
import type { EventType } from './EventType';
import {
    EventTypeFromJSON,
    EventTypeFromJSONTyped,
    EventTypeToJSON,
    EventTypeToJSONTyped,
} from './EventType';
import type { EventStatus } from './EventStatus';
import {
    EventStatusFromJSON,
    EventStatusFromJSONTyped,
    EventStatusToJSON,
    EventStatusToJSONTyped,
} from './EventStatus';

/**
 * 
 * @export
 * @interface CalendarEvent
 */
export interface CalendarEvent {
    /**
     * 
     * @type {string}
     * @memberof CalendarEvent
     */
    calendarId: string;
    /**
     * 
     * @type {string}
     * @memberof CalendarEvent
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof CalendarEvent
     */
    description: string | null;
    /**
     * 
     * @type {EventType}
     * @memberof CalendarEvent
     */
    eventType: EventType;
    /**
     * 
     * @type {Date}
     * @memberof CalendarEvent
     */
    startDateTime: Date;
    /**
     * 
     * @type {Date}
     * @memberof CalendarEvent
     */
    endDateTime: Date;
    /**
     * 
     * @type {boolean}
     * @memberof CalendarEvent
     */
    isRecurring: boolean;
    /**
     * 
     * @type {EventStatus}
     * @memberof CalendarEvent
     */
    status: EventStatus | null;
    /**
     * 
     * @type {CalendarEventLocation}
     * @memberof CalendarEvent
     */
    eventLocation: CalendarEventLocation | null;
    /**
     * 
     * @type {any}
     * @memberof CalendarEvent
     */
    subjectId: any | null;
    /**
     * 
     * @type {string}
     * @memberof CalendarEvent
     */
    subjectName: string | null;
}



/**
 * Check if a given object implements the CalendarEvent interface.
 */
export function instanceOfCalendarEvent(value: object): value is CalendarEvent {
    if (!('calendarId' in value) || value['calendarId'] === undefined) return false;
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('eventType' in value) || value['eventType'] === undefined) return false;
    if (!('startDateTime' in value) || value['startDateTime'] === undefined) return false;
    if (!('endDateTime' in value) || value['endDateTime'] === undefined) return false;
    if (!('isRecurring' in value) || value['isRecurring'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('eventLocation' in value) || value['eventLocation'] === undefined) return false;
    if (!('subjectId' in value) || value['subjectId'] === undefined) return false;
    if (!('subjectName' in value) || value['subjectName'] === undefined) return false;
    return true;
}

export function CalendarEventFromJSON(json: any): CalendarEvent {
    return CalendarEventFromJSONTyped(json, false);
}

export function CalendarEventFromJSONTyped(json: any, ignoreDiscriminator: boolean): CalendarEvent {
    if (json == null) {
        return json;
    }
    return {
        
        'calendarId': json['calendarId'],
        'title': json['title'],
        'description': json['description'],
        'eventType': EventTypeFromJSON(json['eventType']),
        'startDateTime': (new Date(json['startDateTime'])),
        'endDateTime': (new Date(json['endDateTime'])),
        'isRecurring': json['isRecurring'],
        'status': EventStatusFromJSON(json['status']),
        'eventLocation': CalendarEventLocationFromJSON(json['eventLocation']),
        'subjectId': json['subjectId'],
        'subjectName': json['subjectName'],
    };
}

export function CalendarEventToJSON(json: any): CalendarEvent {
    return CalendarEventToJSONTyped(json, false);
}

export function CalendarEventToJSONTyped(value?: CalendarEvent | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'calendarId': value['calendarId'],
        'title': value['title'],
        'description': value['description'],
        'eventType': EventTypeToJSON(value['eventType']),
        'startDateTime': value['startDateTime'].toISOString(),
        'endDateTime': value['endDateTime'].toISOString(),
        'isRecurring': value['isRecurring'],
        'status': EventStatusToJSON(value['status']),
        'eventLocation': CalendarEventLocationToJSON(value['eventLocation']),
        'subjectId': value['subjectId'],
        'subjectName': value['subjectName'],
    };
}

